import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Modal from "react-modal";
import { toast } from "react-toastify";
import Button from "react-bootstrap/Button";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { fetchRequestedCuponsData } from "../../redux/reducers/apiSlice";
import { getAllGymPlans } from "../../redux/reducers/postApiSlice";
import {
  commonPostPutApi,
  fetchApiData,
} from "../../redux/reducers/commonApiSlice";
// import { showConfirmAlert } from "../components-react/ReactAlert";
import { apply_cupon } from "../../data/ApiEndpoints";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import {
  convertThenFormat,
  formatDateTimezon,
  formattedLongDate,
} from "../common-data/Converts";
// import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
// import SelectDropdown from "../components-react/SelectDropdown";
import CuponRequestMobile from "./CuponRequestMobile";
import CuponListMobile from "./CuponListMobile";
import Loader from "../ui/Loader";

const CuponRequestTabs = ({
  userInfoData,
  isPage,
  setIsPage,
  filters,
  selectedTab,
  handleTabSelect,
  handleReset,
  getComineReload,
  setGetComineReload,
}) => {
  const dispatch = useDispatch();

  const { loading, requestedCupons } = useSelector((state) => state.api);
  const {
    loading: postApiLoading,
    data,
    error,
  } = useSelector((state) => state.postApi);
  const { postPutLoading, data: commonGetData } = useSelector(
    (state) => state.common
  );

  const iniPTDatas = {
    allPlans: [],
    pagination: [],
    allCupons: [],
    extendableDays: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);
  // const iniFormvalues = {
  //   selectExtendableDays: "",
  // };
  // const [formValues, setFormValues] = useState(iniFormvalues);

  function onCloseModalvalues() {
    setModValues(iniModvalues);
    setAllDatas((prevs) => ({
      ...prevs,
      allCupons: [],
    }));
  }

  function onExtendableModal() {
    setModValues((prevs) => ({
      ...prevs,
      isModOpenExtendDays: false,
      rowDataExtendDays: "",
    }));
    // setFormValues(iniFormvalues);
    setAllDatas((prevs) => ({
      ...prevs,
      extendableDays: [],
    }));
  }

  // const onChangeDropdown = (name, value) => {
  //   setFormValues((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };

  function getRequestedCupons(filters) {
    dispatch(
      fetchRequestedCuponsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const getGymPlans = async (requestBody) => {
    const TOKEN = userInfoData?.token || "";

    try {
      const result = await dispatch(getAllGymPlans({ requestBody, TOKEN }));

      if (result?.payload?.status) {
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const handleApplyOffer = async (requestBody) => {
    // const handleConfirm = async () => {
      const method = "PUT";
      const endpoint = apply_cupon;
      const payload = requestBody;
      const token = userInfoData?.token || "";

      try {
        const result = await dispatch(
          commonPostPutApi({ method, endpoint, payload, token })
        );

        if (result?.payload?.status) {
          toast.success(result?.payload?.message || "Success!");
          onCloseModalvalues();
          handleReset();
          // getRequestedCupons(filters);
        } else {
          const errorMessage =
            result?.error?.message || result?.payload?.message;
          toast.error(errorMessage || "Something Went Wrong!");
        }
      } catch (error) {
        console.error("Error making POST request:", error);
      }
    // };

    // showConfirmAlert(
    //   handleConfirm,
    //   `Are you sure, you want to apply this request!`
    // );
  };

  function getCuponRequests(filters) {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: apply_cupon,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );

    if (setGetComineReload) {
      setGetComineReload(false);
    }
  }

  const onSubmit = () => {
    const payload = {
      request_id: modValues.rowData?.uid,
      approval_status: "approved",
      approved_coupon: modValues.rowDataExtendDays?.coupon,
      approved_by: userInfoData?.user_id || userInfoData?.uid,
      extendable_days: modValues?.rowDataExtendDays?.extend_days || 0,
      // extendable_days: formValues?.selectExtendableDays?.value || 0,
    };

    handleApplyOffer(payload);
  };

  useEffect(() => {
    if (selectedTab !== 0) {
      if (selectedTab === 1) {
        filters.status = "pending";
      } else if (selectedTab === 2) {
        filters.status = "approved";
      } else if (selectedTab === 3) {
        filters.status = "cancelled";
      } else if (selectedTab === 4) {
        filters.status = "removed";
      }

      getCuponRequests(filters);
    } else {
      getRequestedCupons(filters);
    }
  }, [filters, selectedTab]);

  useEffect(() => {
    if (selectedTab !== 0) {
      if (commonGetData?.status && commonGetData?.data?.length > 0) {
        setAllDatas((prevs) => ({
          ...prevs,
          allPlans: commonGetData.data,
          pagination: commonGetData.pagination,
        }));
      } else {
        setAllDatas((prevs) => ({
          ...prevs,
          allPlans: [],
          pagination: [],
        }));
      }
    } else {
      if (requestedCupons?.status && requestedCupons?.data?.length > 0) {
        setAllDatas((prevs) => ({
          ...prevs,
          allPlans: requestedCupons.data,
          pagination: requestedCupons.pagination,
        }));
      } else {
        setAllDatas((prevs) => ({
          ...prevs,
          allPlans: [],
          pagination: [],
        }));
      }
    }
  }, [requestedCupons, commonGetData, selectedTab]);

  useEffect(() => {
    if (modValues.rowData?.plan_id) {
      const payload = {
        gym_id: modValues.rowData?.gym_id,
        is_web: 1,
        is_goal: 0,
        plan_id: modValues.rowData?.plan_id,
      };

      getGymPlans(payload);
    }
  }, [modValues]);

  useEffect(() => {
    if (!postApiLoading && !error && data?.status && data?.data?.length > 0) {
      const extendableDaysArray = JSON.parse(
        data.data?.[0]?.extendable_days || "[]"
      );
      const extendable_days = extendableDaysArray?.map((day) => ({
        label: day.days,
        value: day.days,
      }));

      setAllDatas((prevs) => ({
        ...prevs,
        allCupons: data.data?.[0]?.price_details,
        extendableDays: extendable_days,
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        allCupons: [],
        extendableDays: [],
      }));
    }
  }, [data, postApiLoading, error]);

  useEffect(() => {
    if (getComineReload) {
      getCuponRequests(filters);
    }
  }, [getComineReload]);

  const tbColumns = [
    (selectedTab === 0 || selectedTab === 1) && {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon view"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "coupon_list",
                rowData: row,
              }))
            }
            style={{
              border: "1px solid #bc0909",
              color: "#bc0909",
              borderRadius: "12px",
              cursor: row?.status !== "pending" ? "not-allowed" : "pointer",
              opacity: row?.status !== "pending" ? 0.5 : 1,
              textTransform: "capitalize",
            }}
            disabled={row?.status !== "pending"}
          >
            approve
          </button>

          {/* <button
              className="actionBtn icon view"
              onClick={() => {
                const { status, uid, coupon } = row || {};
                if (status !== "pending") return;

                const payload = {
                  request_id: uid,
                  approval_status: "rejected",
                  approved_coupon: coupon || "",
                  approved_by: userInfoData?.user_id || userInfoData?.uid,
                };

                handleApplyOffer(payload, "cancell");
              }}
              style={{
                border: "1px solid #bc0909",
                color: "#bc0909",
                borderRadius: "12px",
                cursor: row?.status !== "pending" ? "not-allowed" : "pointer",
                opacity: row?.status !== "pending" ? 0.5 : 1,
                textTransform: "capitalize",
              }}
              disabled={row?.status !== "pending"}
            >
              cancell
            </button> */}
          {/* {postApiLoading ? (
              <Loader />
            ) : (
              <button
                className="actionBtn icon view"
                onClick={() =>
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "coupon_list",
                    rowData: row,
                  }))
                }
                style={{
                  border: "1px solid #bc0909",
                  color: "#bc0909",
                  borderRadius: "12px",
                  cursor: row?.status !== "pending" ? "not-allowed" : "pointer",
                  opacity: row?.status !== "pending" ? 0.5 : 1,
                }}
                disabled={row?.status !== "pending"}
              >
                View Coupons
              </button>
            )} */}
        </div>
      ),
    },
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "user_name",
      text: "user",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.user_name || "NA"}
            <br />
            <small
              style={{
                textTransform: "lowercase",
              }}
            >
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "plan_name",
      text: "plan",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.plan_name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "request date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date ? formatDateTimezon(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27"
            style={{
              background: row?.status === "approved" ? "#E2EFD5" : "#F3DADA",
              color: row?.status === "approved" ? "#379C00" : "#D90000",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    selectedTab !== 1 &&
      selectedTab !== 3 && {
        dataField: "approved_coupon",
        text: "approved coupon",
        formatter: (cell, row) => {
          return (
            <span className="tb-data minWidth100">
              {row?.approved_coupon || "-"}
              <br />({row?.extendable_days || 0} Days)
            </span>
          );
        },
      },
    {
      dataField: "agent_name",
      text: "agent",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.agent_name || "NA"}
            <br />
            <small
              style={{
                textTransform: "lowercase",
              }}
            >
              {row?.agent_mobile || ""}
              <br />
              {row?.agent_email || ""}
            </small>
          </span>
        );
      },
    },
    selectedTab !== 1 &&
      selectedTab !== 3 && {
        dataField: "approved_by_name",
        text: "approved by",
        formatter: (cell, row) => {
          return (
            <span className="tb-data">
              {row?.approved_by_name || "NA"}
              <br />
              <small
                style={{
                  textTransform: "lowercase",
                }}
              >
                {row?.approved_by_mobile || ""}
                <br />
                {row?.approved_by_email || ""}
              </small>
            </span>
          );
        },
      },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formattedLongDate(row.date_added) : "-"}
          </span>
        );
      },
    },
  ];

  const tbColumnsPD = [
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon"
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModOpenExtendDays: true,
                rowDataExtendDays: row,
              }));

              // const payload = {
              //   request_id: row?.uid,
              //   approval_status: "approved",
              //   approved_coupon: row?.coupon,
              //   approved_by: userInfoData?.user_id || userInfoData?.uid,
              // };

              // handleApplyOffer(payload);
            }}
            style={{
              border: "1px solid #bc0909",
              color: "#bc0909",
              borderRadius: "12px",
              cursor: "pointer",
              textTransform: "capitalize",
            }}
          >
            apply offer
          </button>

          {/* {postPutLoading ? (
            <Loader />
          ) : (
            <>
              <button
                className="actionBtn icon"
                onClick={() => {
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpenExtendDays: true,
                    rowDataExtendDays: row,
                  }));

                  // const payload = {
                  //   request_id: row?.uid,
                  //   approval_status: "approved",
                  //   approved_coupon: row?.coupon,
                  //   approved_by: userInfoData?.user_id || userInfoData?.uid,
                  // };

                  // handleApplyOffer(payload);
                }}
                style={{
                  border: "1px solid #bc0909",
                  color: "#bc0909",
                  borderRadius: "12px",
                  cursor: "pointer",
                  textTransform: "capitalize",
                }}
              >
                apply offer
              </button>
            </>
          )} */}
        </div>
      ),
    },
    {
      dataField: "plan_price",
      text: "plan price",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.plan_price || 0)}
          </span>
        );
      },
    },
    {
      dataField: "extend_days",
      text: "extendable days",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.extend_days || 0} Days</span>;
      },
    },
    {
      dataField: "type",
      text: "plan type",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.type?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.status || "NA"}</span>;
      },
    },
    {
      dataField: "coupon",
      text: "coupon",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.coupon || "-"}</span>;
      },
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModalvalues}
        contentLabel="Cupon Requests"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer`}>
          <ModalHeadAndClose
            title={`${modValues.cardName?.replace(/_/g, " ")}`}
            onClose={onCloseModalvalues}
          />

          {modValues.cardName === "coupon_list" ? (
            <>
              <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile mt30">
                <PaymentLinkTable
                  tableData={allDatas.allCupons}
                  tableColumns={tbColumnsPD}
                />
              </div>

              <div className="lead-logs-card-container only-mobile">
                <CuponListMobile
                  tableData={allDatas.allCupons}
                  setModValues={setModValues}
                />
              </div>
            </>
          ) : null}
        </div>
      </Modal>

      <Modal
        isOpen={modValues.isModOpenExtendDays}
        onRequestClose={onExtendableModal}
        contentLabel="Cupon Requests"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer mod-width-50p">
          <ModalHeadAndClose
            title={"Offer Details"}
            onClose={onExtendableModal}
          />

          <div className="mod-container-centered mt30">
            <div className="confirmation-extend-modal">
              <p className="offer-price">
                <span>Offer Amount:</span>
                <span>
                  ₹
                  {convertThenFormat(
                    modValues?.rowDataExtendDays?.plan_price || 0
                  )}
                </span>
              </p>
              <p className="offer-price">
                <span>Extendable Days:</span>
                <span>
                  {modValues?.rowDataExtendDays?.extend_days || 0} Days
                </span>
              </p>
            </div>

            <div className="btns-container">
              <Button type="button" variant="danger" onClick={onSubmit}>
                {postPutLoading ? <Loader /> : "Proceed"}
              </Button>{" "}
              <Button type="button" variant="dark" onClick={onExtendableModal}>
                cancel
              </Button>
            </div>
          </div>

          <>
            {/* <CommonHeadingNBtns
            title="Extend Days"
            btnTxt={"Proceed"}
            onClose={onExtendableModal}
            onClick={onSubmit}
            isLoading={postPutLoading}
          /> */}

            {/* <form className="formContainer">
            <div className="formInputsGrid twoGridSystem">
              <div className="formInputBox">
                <label
                  htmlFor="selectExtendableDays"
                  className="formInputLabel"
                >
                  Extend Days
                </label>

                <div className={`commonWrapper`}>
                  <SelectDropdown
                    options={allDatas.extendableDays}
                    selectedOption={formValues.selectExtendableDays}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selectExtendableDays", selectedValue)
                    }
                    name="Extendable Days"
                  />
                </div>
              </div>
            </div>
          </form> */}
          </>
        </div>
      </Modal>

      <div className="cupon-requests-tabs mt30">
        <Tabs selectedIndex={selectedTab} onSelect={handleTabSelect}>
          <TabList>
            <Tab>all</Tab>
            <Tab>pending</Tab>
            <Tab>approved</Tab>
            <Tab>cancelled</Tab>
            <Tab>removed</Tab>
          </TabList>

          <TabPanel>
            {loading ? (
              <ReactVortoxSpinner />
            ) : (
              <>
                <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile mt30">
                  <PaymentLinkTable
                    tableData={allDatas.allPlans}
                    tableColumns={tbColumns}
                    tablePagination={
                      allDatas.pagination?.length > 0 ? allDatas.pagination : []
                    }
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                  />
                </div>

                <div className="lead-logs-card-container only-mobile">
                  <CuponRequestMobile
                    tableData={allDatas.allPlans}
                    tablePagination={
                      allDatas.pagination?.length > 0 ? allDatas.pagination : []
                    }
                    isPage={isPage}
                    setIsPage={setIsPage}
                    selectedTab={selectedTab}
                    setModValues={setModValues}
                  />
                </div>
              </>
            )}
          </TabPanel>

          <TabPanel>
            {loading ? (
              <ReactVortoxSpinner />
            ) : (
              <>
                <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile mt30">
                  <PaymentLinkTable
                    tableData={allDatas.allPlans}
                    tableColumns={tbColumns}
                    tablePagination={
                      allDatas.pagination?.length > 0 ? allDatas.pagination : []
                    }
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                  />
                </div>

                <div className="lead-logs-card-container only-mobile">
                  <CuponRequestMobile
                    tableData={allDatas.allPlans}
                    tablePagination={
                      allDatas.pagination?.length > 0 ? allDatas.pagination : []
                    }
                    isPage={isPage}
                    setIsPage={setIsPage}
                    selectedTab={selectedTab}
                    setModValues={setModValues}
                  />
                </div>
              </>
            )}
          </TabPanel>

          <TabPanel>
            {loading ? (
              <ReactVortoxSpinner />
            ) : (
              <>
                <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile mt30">
                  <PaymentLinkTable
                    tableData={allDatas.allPlans}
                    tableColumns={tbColumns}
                    tablePagination={
                      allDatas.pagination?.length > 0 ? allDatas.pagination : []
                    }
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                  />
                </div>

                <div className="lead-logs-card-container only-mobile">
                  <CuponRequestMobile
                    tableData={allDatas.allPlans}
                    tablePagination={
                      allDatas.pagination?.length > 0 ? allDatas.pagination : []
                    }
                    isPage={isPage}
                    setIsPage={setIsPage}
                    selectedTab={selectedTab}
                    setModValues={setModValues}
                  />
                </div>
              </>
            )}
          </TabPanel>

          <TabPanel>
            {loading ? (
              <ReactVortoxSpinner />
            ) : (
              <>
                <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile mt30">
                  <PaymentLinkTable
                    tableData={allDatas.allPlans}
                    tableColumns={tbColumns}
                    tablePagination={
                      allDatas.pagination?.length > 0 ? allDatas.pagination : []
                    }
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                  />
                </div>

                <div className="lead-logs-card-container only-mobile">
                  <CuponRequestMobile
                    tableData={allDatas.allPlans}
                    tablePagination={
                      allDatas.pagination?.length > 0 ? allDatas.pagination : []
                    }
                    isPage={isPage}
                    setIsPage={setIsPage}
                    selectedTab={selectedTab}
                    setModValues={setModValues}
                  />
                </div>
              </>
            )}
          </TabPanel>

          <TabPanel>
            {loading ? (
              <ReactVortoxSpinner />
            ) : (
              <>
                <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile mt30">
                  <PaymentLinkTable
                    tableData={allDatas.allPlans}
                    tableColumns={tbColumns}
                    tablePagination={
                      allDatas.pagination?.length > 0 ? allDatas.pagination : []
                    }
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                  />
                </div>

                <div className="lead-logs-card-container only-mobile">
                  <CuponRequestMobile
                    tableData={allDatas.allPlans}
                    tablePagination={
                      allDatas.pagination?.length > 0 ? allDatas.pagination : []
                    }
                    isPage={isPage}
                    setIsPage={setIsPage}
                    selectedTab={selectedTab}
                    setModValues={setModValues}
                  />
                </div>
              </>
            )}
          </TabPanel>
        </Tabs>
      </div>
    </>
  );
};

export default CuponRequestTabs;
